import styled, { css } from 'styled-components';
import { Image as BoltImage } from '@sainsburys-tech/bolt';
var labelStyling = css(["font-size:", ";font-weight:", ";line-height:", ";"], function (props) {
  return props.theme.font.size['label-1'];
}, function (props) {
  return props.theme.font.weight['label-1'];
}, function (props) {
  return props.theme.font['line-height']['label-1'];
});
var Container = styled.div.withConfig({
  displayName: "ColourAndFabricPickerstyles__Container",
  componentId: "sc-1h6h2fd-0"
})(["display:flex;flex-direction:column;border-bottom:1px solid ", ";padding:15px 0;"], function (props) {
  return props.theme.color.monochrome.light;
});
var Header = styled.div.withConfig({
  displayName: "ColourAndFabricPickerstyles__Header",
  componentId: "sc-1h6h2fd-1"
})(["display:flex;justify-content:space-between;"]);
var Title = styled.span.withConfig({
  displayName: "ColourAndFabricPickerstyles__Title",
  componentId: "sc-1h6h2fd-2"
})(["", ""], labelStyling);
var Price = styled.span.withConfig({
  displayName: "ColourAndFabricPickerstyles__Price",
  componentId: "sc-1h6h2fd-3"
})(["", ""], labelStyling);
var Tiles = styled.div.withConfig({
  displayName: "ColourAndFabricPickerstyles__Tiles",
  componentId: "sc-1h6h2fd-4"
})(["display:flex;flex-wrap:wrap;align-items:flex-start;gap:10px;margin-top:15px;"]);
var TileContainer = styled.div.withConfig({
  displayName: "ColourAndFabricPickerstyles__TileContainer",
  componentId: "sc-1h6h2fd-5"
})(["width:80px;overflow-wrap:break-word;"]);
var Tile = styled.button.withConfig({
  displayName: "ColourAndFabricPickerstyles__Tile",
  componentId: "sc-1h6h2fd-6"
})(["position:relative;border:none;font:inherit;background:none;padding:0;margin-bottom:5px;"]);
var Image = styled(BoltImage).withConfig({
  displayName: "ColourAndFabricPickerstyles__Image",
  componentId: "sc-1h6h2fd-7"
})(["display:block;border-radius:2px;", ""], function (props) {
  return props.$isSelected && css(["border:2px solid ", ";padding:3px;"], props.theme.color.palette['blue-60']);
});
var TileText = styled.span.withConfig({
  displayName: "ColourAndFabricPickerstyles__TileText",
  componentId: "sc-1h6h2fd-8"
})(["display:block;text-align:center;line-height:", ";"], function (props) {
  return props.theme.font['line-height']['label-1'];
});
var TagContainer = styled.div.withConfig({
  displayName: "ColourAndFabricPickerstyles__TagContainer",
  componentId: "sc-1h6h2fd-9"
})(["display:flex;margin-top:10px;"]);
var Tag = styled.div.withConfig({
  displayName: "ColourAndFabricPickerstyles__Tag",
  componentId: "sc-1h6h2fd-10"
})(["border:1px solid ", ";color:", ";margin:10px 10px 0 0;padding:0 8px;border-radius:2px;"], function (props) {
  return props.theme.color.semantic.info.light;
}, function (props) {
  return props.theme.color.semantic.info.light;
});
export { Container, Header, Title, Price, Tiles, TileContainer, Tile, Image, TileText, TagContainer, Tag };